import { Form } from 'react-bootstrap';
import { LabelSwitchProps } from '../_models';
import { useId } from 'react';

const LabelSwitch: React.FC<LabelSwitchProps> = ({
  label,
  checked,
  onChange,
}) => {
  const id = useId();

  const isShort = label.length < 4;

  const customSwitchStyles = `
    #switch-${CSS.escape(id)}::after,
    #switch-${CSS.escape(id)}:checked::after {
      content: '${label.toUpperCase()}';
    }
    ${
      isShort
        ? `
      #switch-${CSS.escape(id)}::after,
      #switch-${CSS.escape(id)}:checked::after {
        font-size: 16px;
      }
      @media (max-width: 767px) {
        #switch-${CSS.escape(id)}::after,
        #switch-${CSS.escape(id)}:checked::after {
          font-size: 14px;
        }
      }
    `
        : ''
    }
  `;

  return (
    <>
      <style>{customSwitchStyles}</style>
      <Form.Check
        id={`switch-${id}`}
        type="switch"
        checked={checked}
        onChange={onChange}
        className="label-switch"
      />
    </>
  );
};

export default LabelSwitch;
